import { Component, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalConfig, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-podcast-disclaimer-modal',
  templateUrl:'./podcast-disclaimer-modal.component.html',
  styleUrls: ['./podcast-disclaimer-modal.component.scss'],
})
export class PodcastDisclaimerModalComponent implements AfterViewInit {
  @ViewChild('content', { static: true }) private contentRef!: TemplateRef<any>;


  form: FormGroup;
  modalReference: NgbModalRef | null = null;
  consentAccepted: boolean = false;

  constructor(private fb: FormBuilder, config: NgbModalConfig,
    private modalService: NgbModal) {
    this.form = this.fb.group({
      agree: [false]
    });
  }

  ngAfterViewInit() {
   this.checkConsent();
  }

  openModal() {
    this.modalReference = this.modalService.open(this.contentRef, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });

  }

  checkConsent() {
    //const consent = this.getCookie('consent');
    const consent = sessionStorage.getItem('podcastDisclaimerAccepted');
    if (consent === 'true') {
      this.consentAccepted = true;
    } else {
      this.openModal();
    }
  }



  proceed() {
    if (this.form.get('agree')?.value === true) {
      this.consentAccepted = true;
      //this.setCookie('consent', 'accepted', 365);
      sessionStorage.setItem('podcastDisclaimerAccepted', "true");
      this.closeModal();
    }
  }


 
  closeModal() {
    this.modalService.dismissAll();
  }

}